import { Link } from 'react-router-dom';
import { formatCurrency } from '../lib/currency';
import { localise, useLanguage } from '../lib/i18n';
import { exclVat } from '../lib/PricingContext';

export default function ProductCard({ product, isB2B = false }) {
  const { locale } = useLanguage();
  const name = localise(product, 'name', locale);
  const description = localise(product, 'description', locale);
  const vatRate = product.vatRate ?? 0.06;
  const displayPrice = isB2B ? exclVat(product.price, vatRate) : product.price;

  return (
    <Link
      to={`/products/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block bg-card border border-border rounded-2xl overflow-hidden hover:-translate-y-1 hover:shadow-lg transition-all duration-300"
    >
      <div className="aspect-square overflow-hidden bg-muted">
        {product.imageUrl ? (
          <img
            src={product.imageUrl}
            alt={name}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            loading="lazy"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-muted-foreground/20">
            <span className="font-serif text-5xl">H</span>
          </div>
        )}
      </div>
      <div className="p-4">
        {product.isFeatured && (
          <span className="inline-block text-[10px] font-bold text-accent uppercase tracking-[0.2em] mb-1.5">Uitgelicht</span>
        )}
        <h3 className="font-serif text-base font-medium text-foreground group-hover:text-primary transition-colors leading-snug mb-1">
          {name}
        </h3>
        {description && (
          <p className="text-xs text-muted-foreground line-clamp-2 mb-3 leading-relaxed">{description}</p>
        )}
        <div className="flex items-center gap-2 flex-wrap">
          <span data-testid={`price-${product.slug}`} className="text-sm font-semibold text-foreground">
            {formatCurrency(displayPrice, locale)}
          </span>
          {isB2B && (
            <span className="text-[10px] font-medium text-muted-foreground bg-muted px-1.5 py-0.5 rounded">excl. BTW</span>
          )}
          {!isB2B && product.compareAtPrice && product.compareAtPrice > product.price && (
            <span className="text-xs text-muted-foreground line-through">{formatCurrency(product.compareAtPrice, locale)}</span>
          )}
        </div>
      </div>
    </Link>
  );
}
